$(document).ready(function(){
    $(".mh-drop-down__submenu_item_link").each(function() {
        var $target = $(this);
        if ($target.text().length >= 33) {
            $target.addClass("mh-drop-down__submenu_item_link--long-text");
            var words = $target.text().split(" ");
            var lastWord = words[words.length - 1];
            $target.html(
                $target.text().replace(lastWord, '<span class="last-word">' + lastWord + '</span>')
            );
        }
    });
});
